import { HttpService } from './http.service';
import { methodBuilder, paramBuilder, IAdapterSetting } from './http.utils';

/* *********************************************
 * Method decorators
 * *********************************************/

/**
 * GET method
 * @param {string} url - resource url of the method
 */
export const GET = methodBuilder("GET");
/**
 * POST method
 * @param {string} url - resource url of the method
 */
export const POST = methodBuilder("POST");
/**
 * PUT method
 * @param {string} url - resource url of the method
 */
export const PUT = methodBuilder("PUT");
/**
 * DELETE method
 * @param {string} url - resource url of the method
 */
export const DELETE = methodBuilder("DELETE");
/**
 * HEAD method
 * @param {string} url - resource url of the method
 */
export const HEAD = methodBuilder("HEAD");

/**
 * Defines the adapter function to modify the API response
 * @param adapterFn - function to be called
 * @param adapterSetting - override default setting
 */
export function Adapter(adapterFn?: Function, adapterSetting?: IAdapterSetting): MethodDecorator {
	return function (target: HttpService, propertyKey: string, descriptor: any) {
		descriptor.adapter = adapterFn;
		descriptor.adapterSetting = adapterSetting;
		return descriptor;
	};
}

/* *********************************************
 * Parameter decorators
 * *********************************************/

/**
 * Path variable of a method's url
 * @param {string} key - path key to bind value
 */
export const Path = paramBuilder("Path");

/**
 * Query value of a method's url
 * @param {string} key - query key to bind value
 */
export const Query = paramBuilder("Query");

/**
 * Body of a REST method
 * Only one body per method!
 */
export const Body = paramBuilder("Body")("Body");
